module.exports = __webpack_public_path__ + "img/logo_tk.07d87ad1.png";